import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button';
import { Input } from '../common/FormFields';
import { createAccount } from '../../services/auth/authService';
import { logError } from '../../utils/logger';

export const TokenSignupFlow = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    phone: '',
    address: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await createAccount(formData.email, formData.password);
      navigate('/');
    } catch (err) {
      logError('Token signup failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#3D3F42] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[#2A2B2E] rounded-lg p-8">
          <h2 className="text-2xl font-bold text-white mb-6">Pay-As-You-Go Signup</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="bg-red-500/10 text-red-400 p-4 rounded-lg">
                {error}
              </div>
            )}

            <Input
              label="Email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="bg-gray-700 border-gray-600 text-white"
              labelClassName="text-gray-300"
            />

            <Input
              label="Password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="bg-gray-700 border-gray-600 text-white"
              labelClassName="text-gray-300"
            />

            <Input
              label="Full Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="bg-gray-700 border-gray-600 text-white"
              labelClassName="text-gray-300"
            />

            <Input
              label="Phone Number"
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              required
              className="bg-gray-700 border-gray-600 text-white"
              labelClassName="text-gray-300"
            />

            <Input
              label="Address"
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              required
              className="bg-gray-700 border-gray-600 text-white"
              labelClassName="text-gray-300"
            />

            <Button
              type="submit"
              loading={loading}
              className="w-full bg-red-600 hover:bg-red-700 text-white"
            >
              Create Account
            </Button>
          </form>

          <p className="text-center text-gray-400 mt-4">
            Already have an account?{' '}
            <button
              onClick={() => navigate('/login')}
              className="text-red-400 hover:text-red-300"
            >
              Sign in
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};